<cll-dialog-layout>
    <cll-dialog-header>
        <cll-dialog-title>Add system admin</cll-dialog-title>

    </cll-dialog-header>
    @if(systemAdminFormGroup){
        <div class="dialog-container" [formGroup]="systemAdminFormGroup">
            <div class="dialog-detail">
                <div class="dialog-container-header">
                    <cll-icon type="outlined" [size]="24">info</cll-icon>
                    <span class="dialog-container-header-text">Details</span>
                </div>
                    <cll-form-field label="User" class="small-input">
                        <cll-select [options]="searchableUsersDataSource"
                        [formControl]="systemAdminFormGroup.controls.id" />
                    </cll-form-field>
            </div>
            <span class="dialog-divider"></span>
            @if (addSystemAdmin.error(); as error) {
                <app-error-panel [error]="error" />
            }
            <cll-dialog-footer>
                <button cll-button
                        colour="variant"
                        cllDialogClose>
                    Cancel
                </button>
                <button cll-filled-button
                        colour="secondary"
                        [disabled]="systemAdminFormGroup.invalid || this.addSystemAdmin.loading()"
                        (click)="add()">
                    <cll-icon cllButtonIcon>add</cll-icon>
                    Add
                </button>
            </cll-dialog-footer>
        </div>
    }
</cll-dialog-layout>
